'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _wrapDisplayName = require('recompose/wrapDisplayName');

var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var deprecate = function deprecate(_ref) {
  var name = _ref.name,
      useInstead = _ref.useInstead,
      readMore = _ref.readMore;
  return process && process.env && process.env.NODE_ENV !== 'production' && console && console.error && console.error('Warning: \'' + name + '\' is deprecated and will be removed in the next major version.' + (useInstead ? '\nUse \'' + useInstead + '\' instead.' : '') + (readMore ? '\nRead more on ' + readMore : ''));
};

exports.default = function (_ref2) {
  var name = _ref2.name,
      useInstead = _ref2.useInstead,
      readMore = _ref2.readMore;
  return function (Target) {
    function WithDeprecationWarning(props) {
      deprecate({
        name: name || Target.displayName || Target.name,
        useInstead: useInstead,
        readMore: readMore
      });

      return _react2.default.createElement(Target, props);
    }

    WithDeprecationWarning.displayName = (0, _wrapDisplayName2.default)(Target, 'withDeprecationWarning');

    return WithDeprecationWarning;
  };
};